import { AuthenticationLegacyApi } from './authenticationLegacyApi';
import { AuthenticationOauth2Api } from './authenticationOauth2Api';

class AuthenticationApi {
  readonly legacy: AuthenticationLegacyApi;
  readonly oauth2: AuthenticationOauth2Api;

  constructor() {
    this.legacy = new AuthenticationLegacyApi();
    this.oauth2 = new AuthenticationOauth2Api();
  }
}

const authenticationApi = new AuthenticationApi();

export default authenticationApi;
